import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import PageHeader from "@/components/PageHeader";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/lib/motion";
import { FAQS, IMAGES } from "@/lib/content";

export default function FAQ() {
  return (
    <div className="relative z-10">
      <PageHeader
        overline="Questions & Answers"
        titleLines={["Frequently Asked", <span key="2" className="text-gold italic">Questions</span>]}
        subtitle="Everything you need to know about Scientific Vastu, energy scanning and our consulting process."
        image={IMAGES.energy}
      />
      <section className="py-10 md:py-20">
        <div className="mx-auto max-w-4xl px-6 md:px-8">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="glass rounded-2xl px-6 border-white/10" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display text-xl md:text-2xl hover:no-underline hover:text-gold py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#94A3B8] text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
